<template>
    <div class="col-md-4 col-sm-6 pt-3 pb-3">
        <div class="row">
            <div class="col-3 text-right pr-0 pt-1">
                <img class="lazy" :data-src="itemData.thumbnail" :alt="itemData.thumbnailAlt">
            </div>
            <div class="col-9">
                <h5 class="mt-f-regular mb-lg-2 mb-0">{{itemData.title}}</h5>
                <p class="small mb-0 mt-c-grey">{{itemData.summary}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AboutItem",
        props: {
            itemData: {}
        },
        data() {
            return {}
        }
    }
</script>

<style scoped>
</style>